import swiperUtil from '../utils/swiper-util';

let swiperCarousel = null;

export default (node) => {
  const mainSwiperNode = node.querySelector('[data-main-swiper]');
  const swiperThumbs = node.querySelectorAll('[data-swiper-thumb]');

  // Track current texture for 3-option products
  let currentTexture = null;

  const initSliders = () => {
    swiperCarousel = swiperUtil(mainSwiperNode, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '[data-slider-pagination]',
        clickable: true,
      },
      preventInteractionOnTransition: true,
      breakpoints: {
        1024: {
          direction: 'vertical',
          allowTouchMove: false,
        },
      },
    });
  };

  const checkForVideo = (slide) => {
    const video = slide.querySelector('[data-video-element]');

    if (video) {
      if (video.querySelector('source')) {
        return;
      }
      const mediaData = video.dataset.src;
      let sources = [];
      try {
        const parsedData = JSON.parse(mediaData);
        if (parsedData.sources) {
          sources = parsedData.sources;
        }
      } catch (e) {
        console.error('Error parsing video sources');
        sources = [];
      }

      sources = sources.sort((a, b) => {
        // sort by resolution
        if (a.height < b.height) {
          return 1;
        }
        if (a.height > b.height) {
          return -1;
        }
        return 0;
      });

      sources.forEach((source) => {
        const sourceElement = document.createElement('source');
        sourceElement.src = source.url;
        sourceElement.type = source.mime_type;
        video.appendChild(sourceElement);
      });
    }
  };

  const showHideSlides = (e) => {
    if (!e) {
      return;
    }

    // scroll to top of the page
    if (e.detail.scroll) window.scrollTo(0, 0);

    if (e.detail.option) {
      const currentColorName = e.detail.option;

      // Show/hide slides based on color (and texture for 3-option products)
      const allSlides = node.querySelectorAll('.swiper-slide');
      allSlides.forEach((slide) => {
        const colorValue = slide.getAttribute(
          'data-product-carousel-variant-option'
        );
        const textureValue = slide.getAttribute(
          'data-product-carousel-texture'
        );

        let shouldShow = colorValue === currentColorName;
        // For 3-option products, also filter by texture
        if (shouldShow && textureValue && currentTexture) {
          shouldShow = textureValue === currentTexture;
        }

        if (shouldShow) {
          slide.classList.remove('hidden');
          checkForVideo(slide);
        } else {
          slide.classList.add('hidden');
        }
      });

      setTimeout(() => {
        swiperCarousel.update();
        swiperCarousel.slideTo(0);
      }, 100);
    }
  };

  const handleTextureChange = (e) => {
    const { texture } = e.detail;
    currentTexture = texture;

    // Find the currently visible color
    const allSlides = node.querySelectorAll('.swiper-slide');
    let currentColor = null;
    allSlides.forEach((slide) => {
      if (!slide.classList.contains('hidden')) {
        const colorValue = slide.getAttribute(
          'data-product-carousel-variant-option'
        );
        if (colorValue) currentColor = colorValue;
      }
    });

    if (currentColor) {
      allSlides.forEach((slide) => {
        const colorValue = slide.getAttribute(
          'data-product-carousel-variant-option'
        );
        const textureValue = slide.getAttribute(
          'data-product-carousel-texture'
        );

        let shouldShow = colorValue === currentColor;
        if (shouldShow && textureValue) {
          shouldShow = textureValue === texture;
        }

        if (shouldShow) {
          slide.classList.remove('hidden');
          checkForVideo(slide);
        } else {
          slide.classList.add('hidden');
        }
      });

      setTimeout(() => {
        swiperCarousel.update();
        swiperCarousel.slideTo(0);
      }, 100);
    }
  };

  const handleThumbClick = (thumb) => {
    const { productCarouselIndex } = thumb.dataset;
    swiperCarousel.slideTo(productCarouselIndex);
  };

  /**
   * Init
   */
  initSliders();

  swiperThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => handleThumbClick(thumb));
  });

  document.addEventListener('product-image:scroll-to-image', showHideSlides);
  document.addEventListener('product-image:texture-change', handleTextureChange);

  // Set initial texture from first visible slide (for 3-option products)
  const firstVisibleTextureSlide = node.querySelector(
    '.swiper-slide:not(.hidden)[data-product-carousel-texture]'
  );
  if (firstVisibleTextureSlide) {
    currentTexture = firstVisibleTextureSlide.getAttribute(
      'data-product-carousel-texture'
    );
  }
};
